export function buildApiPayload(config, { instrument, segment, depthInstrumentToken }) {
    const payloadBase = {
        side: config.side,
        mode: config.mode,
        exchange: segment,
        tradingsymbol: instrument.tradingsymbol,
        instrumentToken: depthInstrumentToken || instrument.instrumentToken,
        zerodhaUserId: config.zerodhaUserId ?? null,
        singleLargestOrderValue: config.singleLargestOrderValue ?? null,
        executionMode: (config.executionMode || "AGGRESSIVE").toUpperCase(),
        totalDurationHours: config.totalDurationHours ?? null
    };

    if (config.mode === "PREOPEN") {
        return {
            ...payloadBase,
            expectedQuantity: Number(config.expectedQuantity),
            preopen: {
                preopenOrderDate: config.preopen.preopenOrderDate,
                preopenPriceMode: config.preopen.preopenPriceMode,
                preopenCustomPrice: config.preopen.preopenCustomPrice ?? null,
                preopenTotalOrders: Number(config.preopen.preopenTotalOrders),
                preopenRepeatTillDays: (config.preopen.preopenRepeatTillDays ?? null)
            }
        };
    }

    if (config.mode === "CONSISTENT") {
        return {
            ...payloadBase,
            expectedQuantity: Number(config.expectedQuantity),
            targetPrice: Number(config.targetPrice)
        };
    }

    if (config.mode === "RANGE") {
        return {
            ...payloadBase,
            expectedQuantity: Number(config.expectedQuantity),
            minPrice: Number(config.minPrice),
            maxPrice: Number(config.maxPrice),
            delayMinutes: Number(config.delayMinutes)
        };
    }

    // KEEP_RISE payload
    return {
        ...payloadBase,
        symbols: config.symbols,
        percentRiseFromLastBuy: Number(config.percentRiseFromLastBuy),
        incrementalType: config.incrementalType,
        incrementalValue: Number(config.incrementalValue)
    };
}
